import { Tooltip } from 'antd';

const ProcessBar = ({ data }) => {
    const total = data?.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="flex w-full h-[10px] rounded-full overflow-hidden shadow-inner bg-gray-200">
            {data?.map((item, index) => {
                const widthPercent = total === 0 ? 0 : (item?.count / total) * 100;

                return (
                    <Tooltip
                        key={index}
                        title={`${item?.name}: ${item?.count} (${widthPercent.toFixed(0)}%)`}
                    >
                        <div
                            className="h-full transition-all duration-300 cursor-pointer"
                            style={{
                                width: `${widthPercent}%`,
                                backgroundColor: item?.color,
                            }}
                        />
                    </Tooltip>
                );
            })}
        </div>
    );
};


export default ProcessBar
